import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { fetchIncidentAnalysisData } from '../../../../../../../utils/api/reportAPI';
import UserListTable from './Table/UserList';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
 import axios from 'axios'
import { useSelector } from 'react-redux'
import toasters from '../../../../../../../utils/toasters/Toasters'
import { useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react';


const UserList = () => {
  const location = useLocation();
  const { token } = useSelector((state) => state?.auth)


    const [searchParams] = useSearchParams();
    const [payload, setPayload] = useState(null);

   useEffect(() => {

  // Read correct params from URL
  const userType = searchParams.get('userType');
  const includeInactiveDevices = searchParams.get('includeInactiveDevices');
  const code = searchParams.get('code');

  if (userType || includeInactiveDevices) {
    const urlPayload = {
      userType,
      includeInactiveDevices: includeInactiveDevices === 'true',
      code
    };

    setPayload(urlPayload);
    sessionStorage.setItem('userListPayload', JSON.stringify(urlPayload));
    return;
  }

  // fallback to location.state
  if (location.state) {
    setPayload(location.state);
    sessionStorage.setItem('userListPayload', JSON.stringify(location.state));
    return;
  }

  // fallback to sessionStorage
  const storedPayload = sessionStorage.getItem('userListPayload');
  if (storedPayload) {
    setPayload(JSON.parse(storedPayload));
  }

}, [location.state, searchParams]);

  const {
    data: UserListTableData,
    isLoading,
  } = useQuery(
    ['fetch-user-list', payload],
    () => fetchIncidentAnalysisData({ ...payload, export: 'N' }),
    {
      retry: (failureCount, error) => {
        const status = error?.response?.status;
        return failureCount < 1 && status >= 400 && status < 600; 
      },
      retryDelay: 1000, 
    }
  );
  
  
  const downloadPDF = () => {
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: [297, 210],
  });

  doc.setFontSize(18);
  doc.text('User List Report', 14, 22);
  doc.setFontSize(12);

  let currentY = 30;
  const marginX = 14;
  // Calculate total usable width: 297mm - (14mm * 2) = 269mm
  const pageSize = doc.internal.pageSize;
  const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
  const tableWidth = pageWidth - (marginX * 2);

  UserListTableData?.forEach((user, userIndex) => {
    // Check if we need a new page before starting a new user block
    if (currentY > 180) {
      doc.addPage();
      currentY = 20;
    }

    doc.setFont(undefined, 'bold');
    doc.text(`User: ${user?.users_name_tx || ''}`, marginX, currentY);
    doc.text(`Email: ${user?.email_tx || ''}`, 100, currentY);
    doc.setFont(undefined, 'normal');
    currentY += 6;

    const deviceRows = (user?.devices_array || []).map(device => [
      device?.device_name_tx || '',
      device?.platform_tx || '',
      device?.type_tx || '',
      device?.creat_dt || '',
      device?.note_tx || '',
    ]);

    if (deviceRows.length > 0) {
      doc.autoTable({
        head: [['Device Name', 'Platform', 'Type', 'Created Date', 'Notes']],
        body: deviceRows,
        startY: currentY,
        margin: { left: marginX, right: marginX },
        tableWidth: 'auto', // This forces it to span the margin-to-margin width
        theme: 'grid',
        headStyles: {
          fillColor: [0, 81, 242],
          textColor: [255, 255, 255],
          fontSize: 11,
          halign: 'center'
        },
        bodyStyles: {
          fontSize: 10,
          cellPadding: 3,
          overflow: 'linebreak'
        },
        styles: {
          lineColor: [0, 0, 0],
          lineWidth: 0.2, // Thinner lines look cleaner on full-width
        },
        columnStyles: {
          // Use percentages or proportions to ensure full width coverage
          0: { cellWidth: tableWidth * 0.20 }, // 20% Device Name
          1: { cellWidth: tableWidth * 0.15 }, // 15% Platform
          2: { cellWidth: tableWidth * 0.15 }, // 15% Type
          3: { cellWidth: tableWidth * 0.15 }, // 15% Created Date
          4: { cellWidth: 'auto' },             // Remainder for Notes
        },
        didDrawPage: (data) => {
          currentY = data.cursor.y + 12; 
        },
      });
    } else {
      doc.text('No devices found.', marginX, currentY);
      currentY += 12;
    }
  });

  doc.save('user-list-report.pdf');
}; 
  
  const downloadFile = (data, fileName = 'download') => { 
    const csvBlob = new Blob([data], { type: 'text/csv' });

    const csvUrl = URL.createObjectURL(csvBlob);
    const hiddenElement = document.createElement('a');
    hiddenElement.href = csvUrl;
    hiddenElement.target = '_blank';
    hiddenElement.download = `${fileName}.csv`;
    hiddenElement.click();
};

const ExcelUserList = async () => {
    try {
        let response = await axios.post(
            `${process.env.REACT_APP_API_BACKEND_SERVICE_URL}/reports/report_data`,
            {...payload,export:'Y'},
            {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + token,
                },
            }
        );
        downloadFile(response?.data, 'user-list-report');
    } catch (error) {
        toasters({ type: 'error', message: error?.response?.data?.message });
    }
};

  return (
    <>
      <UserListTable 
        UserListTableData={UserListTableData} 
        downloadPDF={downloadPDF}  
        downloadExcel={ExcelUserList} 
        isLoading={isLoading}
        reportData={payload}
        reportCode={payload?.code}
        reportTableData={UserListTableData}
        generatePDFFunction={downloadPDF}
      />
    </>
  );
};

export default UserList;
